// Copyright 2026, Imprivata, Inc. All rights reserved.

import { FactorType } from '@api/types';

interface CanEnrollOtpParams {
  enableEmailOtp: boolean;
  email?: string;
  userDisplayName?: string;
  authenticators?: { factorType: FactorType }[];
}

const IMPRIVATA_DOMAIN = 'imprivata.id';

export const canEnrollOtp = ({
  enableEmailOtp,
  email,
  userDisplayName,
  authenticators,
}: CanEnrollOtpParams): boolean => {
  const hasValidEmail = !!email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const hasOtpAuthenticator = !!authenticators?.some(auth => auth.factorType === FactorType.OTP);
  const hasImprivataId = !!(
    email?.includes(IMPRIVATA_DOMAIN) || userDisplayName?.includes(IMPRIVATA_DOMAIN)
  );
  return enableEmailOtp && hasValidEmail && hasImprivataId && !hasOtpAuthenticator;
};
